module.exports = fox._r("images/empty-dash-screen.png", __webpack_public_path__ + "_/_/_/common/frame/images/empty-dash-screen.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/empty-dash-screen.png
// module id = 133
// module chunks = 2